/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import 'react-toastify/dist/ReactToastify.min.css';
import { ToastContainer } from 'react-toastify';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { TableSyncProvider } from 'views/ProFormaTable/context/TableSyncContext';
import { PUBLIC_URLS_LIST } from 'services/urls';
import AuthorizedAppRouter from './AuthorizedAppRouter';
import { Auth0TokenProvider } from './contexts/Auth0TokenContext';
import { LoaderProvider } from './contexts/LoaderContext';
import PublicAppRouter from './PublicAppRouter';
import { handleAuthRedirect, HandleNewSocialUser } from './auth';
import { config } from './config';
import { CookieConsentBanner } from './components/CookieConsentBanner';
import './css/main.scss';
import './css/globals/_cursor.scss';

const queryClient = new QueryClient();

const isPublicRoute = PUBLIC_URLS_LIST.some(prefix => window.location.pathname.startsWith(prefix));

const App = () => (
    <QueryClientProvider client={queryClient}>
        <Auth0Provider
            authorizationParams={{
                redirect_uri: window.location.origin,
                audience: config.auth0Audience,
                scope: config.scope,
            }}
            domain={config.auth0Domain as string}
            clientId={config.auth0ClientId as string}
            onRedirectCallback={handleAuthRedirect}
            cacheLocation="memory"
            useRefreshTokens
        >
            <Auth0TokenProvider>
                <LoaderProvider>
                    <TableSyncProvider>
                        <HandleNewSocialUser />
                        {isPublicRoute ? <PublicAppRouter /> : <AuthorizedAppRouter />}
                        <ToastContainer />
                        <CookieConsentBanner />
                    </TableSyncProvider>
                </LoaderProvider>
            </Auth0TokenProvider>
        </Auth0Provider>
    </QueryClientProvider>
);

export default App;
